exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Serif+Text:ital@0;1&display=swap);", ""]);

// module
exports.push([module.id, ".VerificationSuccess-verificationContent-3So9E {\n    text-align: center;\n}\n.VerificationSuccess-titleText-19-D- {\n    font-size: 24px;\n    font-weight: 400;\n    margin-bottom: 32px 0 18px 0;\n    color: #0C3C64;\n    font-family: 'DM Serif Text', serif;\n}\n.VerificationSuccess-contentText-34CDu {\n    font-size: 14px;\n    margin-bottom: 24px;\n    color: #103C62;\n    font-family: 'DM Sans', sans-serif;\n} ", ""]);

// exports
exports.locals = {
	"verificationContent": "VerificationSuccess-verificationContent-3So9E",
	"titleText": "VerificationSuccess-titleText-19-D-",
	"contentText": "VerificationSuccess-contentText-34CDu"
};